export default __webpack_public_path__ + "static/media/PFSquareSansProMediumItalic_35488.7e75f2c6.ttf";